<template>
  <div class="policy-service" :class="[
    {
      'animate__animated animate__zoomOutLeft':
        serviceIsDeleting === service.id,
    },
    { deleting: isDeleted },
  ]">
    <Loading v-if="serviceLoading" />
    <template v-else>
      <div class="policy-service__row">
        <div class="policy-service__data policy-service__data--type">
          {{ code }} <template v-if="mandate"> & {{ mandate.service.code }}</template>
        </div>

        <div class="policy-service__data"
          :class="{ 'policy-service__data--underline': $checkRolePermission('policy_service_edit') }">
          <span v-if="$checkRolePermission('policy_service_edit')" @click="showStartDatePopup = true"
            style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showStartDatePopup" :isDate="true" @togglePopup="showStartDatePopup = $event"
                :selected="unformattedStartDate" @submit="updatePolicyServiceStartDate($event)" />
            </transition>
            {{ startDate }}
          </span>
          <span v-else>
            {{ startDate }}
          </span>
        </div>

        <div class="policy-service__data"
          :class="{ 'policy-service__data--underline': code !== 'KVG' && $checkRolePermission('policy_service_edit') }">
          <span v-if="code !== 'KVG' && $checkRolePermission('policy_service_edit')" @click="showEndDatePopup = true"
            style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showEndDatePopup" :isDate="true" @togglePopup="showEndDatePopup = $event"
                :selected="unformattedEndDate" @submit="updatePolicyServiceEndDate($event)" />
            </transition>
            {{ endDate }}
          </span>
          <span v-else>
            {{ endDate }}
          </span>
        </div>

        <div class="policy-service__data">{{ dueDate }}</div>
        <div class="policy-service__data">
          <span v-if="owner">{{ owner.first_name }} {{ owner.last_name }}</span>
          <span v-else>----------</span>
        </div>
        <div class="policy-service__data service__data--price"
          :class="{ 'policy-service__data--netto': isLastService }">
          <div>{{ nettoPremium }}</div>
          <div class="policy-service__netto" v-if="isLastService">
            <span>Total:</span>{{ totalNetto.toFixed(2) }}
          </div>
        </div>
        <div class="policy-service__data policy-service__data--price" :class="{
          'policy-service__data--underline': $checkRolePermission('policy_service_edit'),
          'policy-service__data--brutto': isLastService
        }">
          <span v-if="$checkRolePermission('policy_service_edit')" @click="showBruttoPremiumPopup = true"
            style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showBruttoPremiumPopup" :isDate="false" @togglePopup="showBruttoPremiumPopup = $event"
                :selected="this.service.bruto_premium" @submit="updatePolicyServiceBruttoPremium($event)" />
            </transition>
            {{ bruttoPremium }}
          </span>

          <span v-else>
            {{ bruttoPremium }}
          </span>

          <span class="policy-service__brutto" v-if="isLastService">
            {{ totalBrutto }} .-CHF
          </span>
        </div>

        <div class="policy-service__data"
          :class="{ 'policy-service__data--underline': $checkRolePermission('policy_service_edit') }">
          <span v-if="$checkRolePermission('policy_service_edit')" @click="showIntervalPopup = true"
            style="cursor: pointer">
            <transition name="fade" mode="in-out">
              <PopupEditer v-if="showIntervalPopup" @togglePopup="showIntervalPopup = $event" :items="intervals"
                :selected="premiumInterval" label="name" :position="'left'"
                @submit="updatePolicyServiceInterval($event)" />
            </transition>
            {{ premiumInterval }}
          </span>

          <span v-else>
            {{ premiumInterval }}
          </span>
        </div>

        <div class="policy-service__data policy-service__data--payment">
          <div 
            v-if="$checkRolePermission('policy_service_payment_access')" 
            class="icon icon__payment" :class="{
              'icon__payment--paid': isPaid,
              'icon__payment--pending': isPaymentEntered && !isPaid
            }" 
            @click="openPolicyProvisionModal()"
          ></div>  
        </div>

        <div class="policy-service__data policy-service__data--delete">
          <div v-if="$checkRolePermission('policy_service_delete')" class="icon icon__delete"
            :class="{ 'icon__delete--active': showDeletePopup, 'is-paid': isPaid }" tabindex="-1"
            @focus="!isPaid && (showDeletePopup = true)" @focusout="!isPaid && (showDeletePopup = false)" ref="delete">
            <transition name="fade">
              <div class="delete" v-if="showDeletePopup">
                <div class="delete__text">
                  Are you sure you want to delete this Service?
                </div>
                <div class="delete__buttons">
                  <div class="button button--confirm" @click="deleteService()"></div>
                  <div class="button button--cancel" @click="closeDeletePopup()"></div>
                </div>
              </div>
            </transition>
          </div>  
        </div>
      </div>
      <div class="policy-service__name">{{ name }} </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from "vuex";
import PopupEditer from "@/partials/PopupEditer";
import Loading from "@/partials/Loading";
import moment from "moment";
import statics from "@/statics";
export default {
  name: "PolicyService",

  components: {
    PopupEditer,
    Loading,
  },

  props: {
    service: {
      required: true,
      type: Object,
    },

    fetchGlobalCustomer: {
      required: true,
      type: Function,
    },

    isLastService: {
      required: true,
      type: Boolean,
    },

    totalNetto: {
      required: true,
      type: Number,
    },

    totalBrutto: {
      required: true,
      type: Number,
    },
    mandate: {
      type: Object,
      required: false
    },
    owner: {
      required: true,

    },

    createdAt: {
      required: true,
      type: String
    },
  },

  data() {
    return {
      showIntervalPopup: false,
      showStartDatePopup: false,
      showEndDatePopup: false,
      serviceLoading: false,
      serviceIsDeleting: "",
      isDeleted: false,
      showDeletePopup: false,
      showBruttoPremiumPopup: false,
    };
  },

  computed: {
    ...mapGetters(["policyForms", "language"]),
    code() {
      return this.service.service ?
        this.service.service.code || statics.empty :
        null;
    },

    unformattedStartDate() {
      return this.service.start_date || statics.empty;
    },

    unformattedEndDate() {
      return this.service.end_date || statics.empty;
    },

    startDate() {
      return this.service.start_date ?
        moment(this.service.start_date.split("T")[0]).format("DD.MM.YYYY") :
        statics.empty;
    },

    endDate() {
      return this.service.end_date ?
        moment(this.service.end_date.split("T")[0]).format("DD.MM.YYYY") :
        statics.empty;
    },

    nettoPremium() {
      return this.service.netto_premium ?
        `${this.service.netto_premium} .-CHF` :
        statics.empty;
    },

    bruttoPremium() {
      return this.service.bruto_premium ?
        `${this.service.bruto_premium} .-CHF` :
        statics.empty;
    },

    premiumInterval() {
      return this.service.premium_interval ?
        this.service.premium_interval.name || statics.empty :
        statics.empty;
    },

    dueDate() {
      return statics.empty;
    },

    name() {
      if (this.service.service_model) {
        return this.service.service_model.name
      }
      return this.service.service ?
        this.service.service[`long_${this.language}`] || statics.empty :
        statics.empty;
    },

    plateNumber() {
      return this.service.plate_number || statics.empty;
    },

    intervals() {
      return this.policyForms.intervals;
    },

    isPaid() {
      if (this.service && this.service.policy_service_payments && this.service.policy_service_payments.length > 0) {
        return this.service.policy_service_payments.every(payment => payment.paid == true);
      }
      return false;
    },

    isPaymentEntered() {
      if (this.service && this.service.policy_service_payments && this.service.policy_service_payments.length > 0) {
        return this.service.policy_service_payments.every(payment => payment !== null && payment !== undefined);
      }
      return false;
    },
  },

  methods: {
    async deleteService() {
      const {
        id
      } = this.$route.params;
      this.serviceIsDeleting = this.service.id;
      this.closeDeletePopup();
      await this.$store.dispatch("deletePolicyService", this.service.id);
      this.isDeleted = true;
      setTimeout(async () => {
        await this.$store.dispatch("getGlobalCustomer", id);
      }, 300);
    },

    async updatePolicyServiceInterval(intervalId) {
      this.serviceLoading = true;
      await this.$store.dispatch("updatePolicyServiceInterval", {
        serviceId: this.service.id,
        intervalId,
      });
      await this.fetchGlobalCustomer(this.$route.params.id);
      this.showIntervalPopup = false;
      this.serviceLoading = false;
    },

    async updatePolicyServiceStartDate(date) {
      this.serviceLoading = true;
      await this.$store.dispatch("updatePolicyServiceStartDate", {
        serviceId: this.service.id,
        date,
      });
      await this.fetchGlobalCustomer(this.$route.params.id);
      this.showStartDatePopup = false;
      this.serviceLoading = false;
    },
    async updatePolicyServiceBruttoPremium(bruttoPremium) {
      this.serviceLoading = true;
      await this.$store.dispatch("updatePolicyServiceBruttoPremium", {
        serviceId: this.service.id,
        bruttoPremium,
      });
      await this.fetchGlobalCustomer(this.$route.params.id);
      this.showBruttoPremiumPopup = false;
      this.serviceLoading = false;
    },

    async updatePolicyServiceEndDate(date) {
      this.serviceLoading = true;
      await this.$store.dispatch("updatePolicyServiceEndDate", {
        serviceId: this.service.id,
        date,
      });
      await this.fetchGlobalCustomer(this.$route.params.id);
      this.showEndDatePopup = false;
      this.serviceLoading = false;
    },

    openPolicyProvisionModal() {
      this.$store.commit("setSelectedPolicyService", this.service);
      this.$store.commit("setShowPolicyProvisionModal", true);

      this.$store.commit("setPolicyCreatedAt", this.createdAt)
    },

    // openPolicyProvisionModal() { 
    //   this.$store.commit("setSelectedPolicyService", this.service);
    //   this.$store.commit("setPolicyCreatedAt", this.createdAt);

    //   this.$store.dispatch("fetchPolicyServicePayments", this.service.id)
    //     .then(() => { 
    //       this.$store.commit("setShowPolicyProvisionModal", true);
    //     })
    //     .catch(err => {
    //       console.error("Could not load service payments:", err); 
    //       this.$store.commit("setShowPolicyProvisionModal", true);
    //     });
    // },

    closeDeletePopup() {
      this.$refs.delete.blur();
      this.showDeletePopup = false;
    },
  },
};
</script>

<style scoped>
.is-paid {
  cursor: not-allowed;
}
</style>
